import type { TextData } from './types';

export function makeDefault(): TextData {
  return {
    text: '',
    fontSize: 14,
    fontWeight: 400,
    color: '#2D3134',
    textAlign: 'left',
    verticalAlign: 'middle',
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
  };
}
